import { useSelector } from "react-redux";

import { SEXES } from "constants/sexes";
import { getSexes } from "selectors";
import { getSkinsSexId } from "selectors/sexes";

// Returns the skins sex ID for the given speciesId, or falls back to the
// current sale's species when inside a sale context.
export function useResolveSkinsSexId(speciesId?: number | null) {
  const sexes = useSelector(getSexes);
  const skinsSexIdFromCurrentSale = useSelector(getSkinsSexId);

  const skinsSexIdFromSpeciesId =
    speciesId != null
      ? Object.values(sexes as Record<string, Sex>).find(
          sex => sex.speciesId === speciesId && sex.name === SEXES.SKINS,
        )?.id
      : null;

  return skinsSexIdFromSpeciesId || skinsSexIdFromCurrentSale;
}
